<script setup lang="ts">
import 'prismjs';
import '../../styles/components/blocks/_prism-theme.scss';
import Prism from 'prismjs';

// NOTE: The parent component *MUST* wrap this one with a <div class="prism"> in order for styles
//       to be applied correctly.

const props = defineProps<{
  language: string;
  code: string;
}>();

const html = computed(() => {
  const prismLanguage = Prism.languages[props.language];
  return Prism.highlight(props.code, prismLanguage);
});

const className = computed(() => `language-${props.language}`);
</script>

<template>
  <pre :class="className"><code v-html="html" :class="className" /></pre>
</template>
